import { Service } from "@/types";
import { atom } from "jotai";

const indoorServiceAtom = atom<Service | null>(null);

export default indoorServiceAtom;
